module.exports = __webpack_public_path__ + "static/media/CTLI_12-111w.fb58b836.jpg";